export default (props = {}) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<g clip-path="url(#clip0_1_42036)">
<circle cx="12.3516" cy="12" r="12" fill="#00DC93"/>
<path d="M11.1216 13.5922L17.5423 7.17244C17.9328 6.78197 18.5659 6.782 18.9564 7.17252L20.0172 8.23334C20.4077 8.62387 20.4077 9.25704 20.0172 9.64755L11.8295 17.8348C11.439 18.2253 10.8058 18.2253 10.4153 17.8348L5.10929 12.5288C4.71875 12.1383 4.71876 11.5051 5.1093 11.1146L6.16999 10.054C6.56055 9.66342 7.19377 9.66346 7.58427 10.0541L11.1216 13.5922Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_1_42036">
<rect width="24" height="24" rx="12" fill="white"/>
</clipPath>
</defs>
</svg>
